webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
'v0.4.6 Geetest Inc.';


(function (window) {
  'use strict';

  if (typeof window === 'undefined') {
    throw new Error('Geetest requires browser environment');
  }

  var document = window.document;
  var Math = window.Math;
  var head = document.getElementsByTagName('head')[0];

  function _Object(obj) {
    this._obj = obj;
  }

  _Object.prototype = {
    _each: function _each(process) {
      var _obj = this._obj;
      for (var k in _obj) {
        if (_obj.hasOwnProperty(k)) {
          process(k, _obj[k]);
        }
      }
      return this;
    }
  };

  function Config(config) {
    var self = this;
    new _Object(config)._each(function (key, value) {
      self[key] = value;
    });
  }

  Config.prototype = {
    api_server: 'api.geetest.com',
    protocol: 'https://',
    typePath: '/gettype.php',
    fallback_config: {
      slide: {
        static_servers: ['static.geetest.com', 'dn-staticdown.qbox.me'],
        type: 'slide',
        slide: '/static/js/geetest.0.0.0.js'
      },
      fullpage: {
        static_servers: ['static.geetest.com', 'dn-staticdown.qbox.me'],
        type: 'fullpage',
        fullpage: '/static/js/fullpage.0.0.0.js'
      }
    },
    _get_fallback_config: function _get_fallback_config() {
      var self = this;
      if (isString(self.type)) {
        return self.fallback_config[self.type];
      } else if (self.new_captcha) {
        return self.fallback_config.fullpage;
      } else {
        return self.fallback_config.slide;
      }
    },
    _extend: function _extend(obj) {
      var self = this;
      new _Object(obj)._each(function (key, value) {
        self[key] = value;
      });
    }
  };
  var isNumber = function isNumber(value) {
    return typeof value === 'number';
  };
  var isString = function isString(value) {
    return typeof value === 'string';
  };
  var isBoolean = function isBoolean(value) {
    return typeof value === 'boolean';
  };
  var isObject = function isObject(value) {
    return (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' && value !== null;
  };
  var isFunction = function isFunction(value) {
    return typeof value === 'function';
  };

  var callbacks = {};
  var status = {};

  var random = function random() {
    return parseInt(Math.random() * 10000) + new Date().valueOf();
  };

  var loadScript = function loadScript(url, cb) {
    var script = document.createElement('script');
    script.charset = 'UTF-8';
    script.async = true;

    script.onerror = function () {
      cb(true);
    };
    var loaded = false;
    script.onload = script.onreadystatechange = function () {
      if (!loaded && (!script.readyState || 'loaded' === script.readyState || 'complete' === script.readyState)) {

        loaded = true;
        setTimeout(function () {
          cb(false);
        }, 0);
      }
    };
    script.src = url;
    head.appendChild(script);
  };

  var normalizeDomain = function normalizeDomain(domain) {
    return domain.replace(/^https?:\/\/|\/$/g, '');
  };
  var normalizePath = function normalizePath(path) {
    path = path.replace(/\/+/g, '/');
    if (path.indexOf('/') !== 0) {
      path = '/' + path;
    }
    return path;
  };
  var normalizeQuery = function normalizeQuery(query) {
    if (!query) {
      return '';
    }
    var q = '?';
    new _Object(query)._each(function (key, value) {
      if (isString(value) || isNumber(value) || isBoolean(value)) {
        q = q + encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&';
      }
    });
    if (q === '?') {
      q = '';
    }
    return q.replace(/&$/, '');
  };
  var makeURL = function makeURL(protocol, domain, path, query) {
    domain = normalizeDomain(domain);

    var url = normalizePath(path) + normalizeQuery(query);
    if (domain) {
      url = protocol + domain + url;
    }

    return url;
  };
  var load = function load(protocol, domains, path, query, cb) {
    var tryRequest = function tryRequest(at) {

      var url = makeURL(protocol, domains[at], path, query);
      loadScript(url, function (err) {
        if (err) {
          if (at >= domains.length - 1) {
            cb(true);
          } else {
            tryRequest(at + 1);
          }
        } else {
          cb(false);
        }
      });
    };
    tryRequest(0);
  };
  var jsonp = function jsonp(domains, path, config, callback) {
    if (isObject(config.getLib)) {
      config._extend(config.getLib);
      callback(config);
      return;
    }
    if (config.offline) {
      callback(config._get_fallback_config());
      return;
    }

    var cb = 'geetest_' + random();
    window[cb] = function (data) {
      if (data.status === 'success') {
        callback(data.data);
      } else if (!data.status) {
        callback(data);
      } else {
        callback(config._get_fallback_config());
      }
      window[cb] = undefined;
      try {
        delete window[cb];
      } catch (e) {}
    };
    load(config.protocol, domains, path, {
      gt: config.gt,
      callback: cb
    }, function (err) {
      if (err) {
        callback(config._get_fallback_config());
      }
    });
  };
  var throwError = function throwError(errorType, config) {
    var errors = {
      networkError: '网络错误',
      gtTypeError: 'gt字段不是字符串类型'
    };
    if (typeof config.onError === 'function') {
      config.onError(errors[errorType]);
    } else {
      throw new Error(errors[errorType]);
    }
  };
  var detect = function detect() {
    return window.Geetest || document.getElementById('gt_lib');
  };
  if (detect()) {
    status.slide = 'loaded';
  }
  window.initGeetest = function (userConfig, callback) {
    var config = new Config(userConfig);
    if (userConfig.https) {
      config.protocol = 'https://';
    } else if (!userConfig.protocol) {
      config.protocol = window.location.protocol + '//';
    }

    if (userConfig.gt === '050cffef4ae57b5d5e529fea9540b0d1' || userConfig.gt === '3bd38408ae4af923ed36e13819b14d42') {
      config.apiserver = 'yumchina.geetest.com/';
      config.api_server = 'yumchina.geetest.com';
    }
    if (isObject(userConfig.getType)) {
      config._extend(userConfig.getType);
    }
    jsonp([config.api_server || config.apiserver], config.typePath, config, function (newConfig) {
      var type = newConfig.type;
      var init = function init() {
        config._extend(newConfig);
        callback(new window.Geetest(config));
      };
      callbacks[type] = callbacks[type] || [];
      var s = status[type] || 'init';
      if (s === 'init') {
        status[type] = 'loading';
        callbacks[type].push(init);
        load(config.protocol, newConfig.static_servers || newConfig.domains, newConfig[type] || newConfig.path, null, function (err) {
          if (err) {
            status[type] = 'fail';
            throwError('networkError', config);
          } else {
            status[type] = 'loaded';
            var cbs = callbacks[type];
            for (var i = 0, len = cbs.length; i < len; i = i + 1) {
              var cb = cbs[i];
              if (isFunction(cb)) {
                cb();
              }
            }
            callbacks[type] = [];
          }
        });
      } else if (s === 'loaded') {
        init();
      } else if (s === 'fail') {
        throwError('networkError', config);
      } else if (s === 'loading') {
        callbacks[type].push(init);
      }
    });
  };
})(window);

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      baseUrl: "https://sso.tuling123.com/sso-api",
      ReturnURl: ''
    };
  },
  created: function created() {
    if (this.getUrlFn('ReturnURL')) {
      var url = this.getUrlFn('ReturnURL');

      if (!this.isValidReturnURL(url)) {
        console.warn('[SSO] Invalid ReturnURL (localhost/internal IP), using default:', url);
        this.ReturnURl = "http://www.tuling123.com/member/index.jhtml";
        localStorage.removeItem('ReturnURL');
        return;
      }
      if (url === 'http://20.dev.tuling123.com/') {
        this.ReturnURl = 'http://20.dev.tuling123.com/member/index.jhtml';
        localStorage.setItem('ReturnURL', 'http://20.dev.tuling123.com/member/index.jhtml');
      } else if (url === 'http://www.tuling123.com/') {
        this.ReturnURl = 'http://www.tuling123.com/member/index.jhtml';
        localStorage.setItem('ReturnURL', 'http://www.tuling123.com/member/index.jhtml');
      } else {
        this.ReturnURl = this.getUrlFn('ReturnURL');
        localStorage.setItem('ReturnURL', this.getUrlFn('ReturnURL'));
      }
    } else {
      if (localStorage.getItem('ReturnURL')) {
        var cachedUrl = localStorage.getItem('ReturnURL');

        if (this.isValidReturnURL(cachedUrl)) {
          this.ReturnURl = cachedUrl;
        } else {
          console.warn('[SSO] Invalid cached ReturnURL, clearing:', cachedUrl);
          localStorage.removeItem('ReturnURL');
          this.ReturnURl = "http://www.tuling123.com/member/index.jhtml";
        }
      } else {
        this.ReturnURl = "http://www.tuling123.com/member/index.jhtml";
      }
    }
    this.ReturnURl = unescape(this.ReturnURl);
  },

  methods: {
    getUrlFn: function getUrlFn(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
    isValidReturnURL: function isValidReturnURL(url) {
      if (!url || typeof url !== 'string') {
        return false;
      }

      var invalidPatterns = [/^https?:\/\/(localhost|127\.0\.0\.1|0\.0\.0\.0)(:|\/|$)/i, /^https?:\/\/192\.168\./i, /^https?:\/\/10\./i, /^https?:\/\/172\.(1[6-9]|2[0-9]|3[0-1])\./i];
      for (var i = 0; i < invalidPatterns.length; i++) {
        if (invalidPatterns[i].test(url)) {
          return false;
        }
      }

      return (/^https?:\/\//i.test(url)
      );
    }
  }
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(102),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0e39c13f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(89)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(101),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-02276cfc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(93)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(105),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4d1f1a7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(91)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(103),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40c4af08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(95)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(107),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f8539c10",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_login_login_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_login_login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_login_login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_register_register_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_register_register_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_register_register_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_findPas_findPas_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_findPas_findPas_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_findPas_findPas_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_third_third_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_third_third_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_third_third_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_reset_css__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__js_geetest_js__ = __webpack_require__(8);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.emulateJSON = true;

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ path: "/sso-web/" + 'login', name: 'login', component: __WEBPACK_IMPORTED_MODULE_4__components_login_login_vue___default.a }, { path: "/sso-web/" + 'index.html', name: 'login', component: __WEBPACK_IMPORTED_MODULE_4__components_login_login_vue___default.a }, { path: "/sso-web/" + 'register', name: 'register', component: __WEBPACK_IMPORTED_MODULE_5__components_register_register_vue___default.a }, { path: "/sso-web/" + 'findPas', name: 'findPas', component: __WEBPACK_IMPORTED_MODULE_6__components_findPas_findPas_vue___default.a }, { path: "/sso-web/" + 'third', name: 'third', component: __WEBPACK_IMPORTED_MODULE_7__components_third_third_vue___default.a }, { path: "/sso-web/" + '*', redirect: "/sso-web/" + 'index.html' }],
  linkActiveClass: 'active'
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
}).$mount('#app');

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    alertshow: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      timer: null,
      isRead: false,
      num: 5
    };
  },

  watch: {
    alertshow: function alertshow(val, oldVal) {
      console.log(1);
      this.toRead();
    }
  },
  beforeDeatory: function beforeDeatory() {
    this.num = 5;
    clearInterval(this.timer);
  },

  methods: {
    toRead: function toRead() {
      clearInterval(this.timer);
      this.num = 5;
      var _this = this;
      this.timer = setInterval(function () {
        _this.num = _this.num - 1;
        if (_this.num <= 0) {
          _this.num = 0;
          clearInterval(_this.timer);
          _this.isRead = true;
        }
      }, 1000);
    },
    close: function close() {
      this.$emit('close');
      clearInterval(this.timer);
      this.num = 5;
    },
    agree: function agree() {
      if (!this.isRead) {
        return false;
      } else {
        this.$parent.onoff = true;
        this.$emit('agree');
        clearInterval(this.timer);
        this.num = 5;
      }
    },
    unagree: function unagree() {
      this.$emit('unagree');
      clearInterval(this.timer);
      this.num = 5;
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    alertshow1: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      timer: null,
      isRead: false,
      num: 5
    };
  },

  watch: {
    alertshow1: function alertshow1(val, oldVal) {
      console.log(2);
      this.toRead();
    }
  },
  beforeDeatory: function beforeDeatory() {
    this.num = 5;
    clearInterval(this.timer);
  },

  methods: {
    toRead: function toRead() {
      clearInterval(this.timer);
      this.num = 5;
      var _this = this;
      this.timer = setInterval(function () {
        _this.num = _this.num - 1;
        if (_this.num <= 0) {
          _this.num = 0;
          clearInterval(_this.timer);
          _this.isRead = true;
        }
      }, 1000);
    },
    close: function close() {
      this.$emit('close1');
      clearInterval(this.timer);
      this.num = 5;
    },
    agree: function agree() {
      if (!this.isRead) {
        return false;
      } else {
        this.$parent.onoff = true;
        this.$emit('agree1');
        clearInterval(this.timer);
        this.num = 5;
      }
    },
    unagree: function unagree() {
      this.$emit('unagree1');
      clearInterval(this.timer);
      this.num = 5;
    }
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_geetest_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_public_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__js_public_js__["a" /* default */]],
  data: function data() {
    return {
      errorMsg: '',
      id: '',
      code: '',
      pass: '',
      repass: '',
      sendMsg: '发送验证码',
      telphone: '',
      codeshow: false
    };
  },
  created: function created() {
    this.id = this.uuid();
    this.$nextTick(function () {
      document.getElementsByTagName('title')[0].innerHTML = '找回密码';
    });
  },

  methods: {
    getJy: function getJy() {
      var _this = this;
      if (this.$refs.jcode.innerHTML) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
        url: _this.baseUrl + '/geetest/v3',
        type: 'POST',
        dataType: 'json',
        data: { id: _this.id },
        xhrFields: {
          withCredentials: true
        },
        success: function success(res) {
          if (res.type === 'success') {
            window.initGeetest({
              gt: res.data.gt,
              challenge: res.data.challenge,
              new_captcha: res.data.new_captcha,
              product: 'popup',
              width: '100%',
              offline: !res.data.success
            }, _this.handlerPopup);
          }
        }
      });
    },
    sendyzm: function sendyzm() {
      var phonetest = /^1[0-9]{10}$/;
      var emailtest = /^[A-Za-z0-9]+([-_.][A-Za-z0-9]+)*@([A-Za-z0-9]+[-.])+[A-Za-zd]{2,5}$/;
      var _this = this;
      if (this.sendMsg.length !== 5) {
        return;
      }
      if (!phonetest.test(this.telphone) && !emailtest.test(this.telphone)) {
        this.errorMsg = '请输入正确的手机号码或邮箱';
        return;
      }

      if (emailtest.test(this.telphone)) {
        var url = '';
        var eml = '';
        var tel = '';
        url = _this.baseUrl + '/find/password/send/2';
        eml = _this.telphone;
        __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
          url: url,
          type: 'POST',
          dataType: 'json',
          data: { mobile: tel, email: eml },
          xhrFields: {
            withCredentials: true
          },
          success: function success(data) {
            if (data.type === 'success') {
              _this.errorMsg = '';
              _this.toCode(tel);
            } else if (data.code === 11140301 || data.code === 11140302) {
              _this.errorMsg = '用户名不存在，';
            } else {
              _this.errorMsg = '操作频繁，请稍后再试';
            }
          }
        });
      } else {
        this.getJy();
        this.codeshow = true;
        this.errorMsg = '请进行图片验证';
      }
    },
    toCode: function toCode(txt) {
      var _this = this;
      var i = txt ? 60 : 270;
      this.sendMsg = i + '秒';
      var nu = setInterval(function () {
        i--;
        _this.sendMsg = i + '秒';
        if (i === 0) {
          clearInterval(nu);
          _this.sendMsg = '发送验证码';
        }
      }, 1000);
    },
    handlerPopup: function handlerPopup(captchaObj) {
      var _this = this;
      captchaObj.appendTo('.jtocode');
      captchaObj.onReady(function () {
        setTimeout(function () {
          document.getElementsByClassName('geetest_radar_btn')[0].click();
        }, 16);
      });
      captchaObj.onSuccess(function () {
        var validate = captchaObj.getValidate();
        _this.errorMsg = '';
        setTimeout(function () {
          _this.codeshow = false;
        }, 1500);
        _this.$http.post(_this.baseUrl + '/common/exist-user', { u: _this.telphone }).then(function (res) {
          if (res.body.type === 'success') {
            if (res.body.data) {
              var url = '';
              var tel = '';
              var eml = '';
              if (_this.telphone.indexOf('@') >= 0) {
                url = _this.baseUrl + '/find/password/send/2';
                eml = _this.telphone;
              } else {
                url = _this.baseUrl + '/find/password/send/1';
                tel = _this.telphone;
              }
              __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: { geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, mobile: tel, email: eml },
                xhrFields: {
                  withCredentials: true
                },
                success: function success(data) {
                  if (data.type === 'success') {
                    _this.errorMsg = '';
                    _this.toCode(tel);
                    captchaObj.reset();
                  } else {
                    _this.errorMsg = '操作频繁，请稍后再试';
                    captchaObj.reset();
                  }
                }
              });
            } else {
              _this.errorMsg = '该账号不存在';
              captchaObj.reset();
            }
          }
        }, function () {
          _this.errorMsg = '网络错误，请稍后重试';
        });
      });
    },
    sure: function sure() {
      var _this = this;
      var re = /^\d+$/;
      var re1 = /^[a-zA-Z]+$/;
      var re2 = /^[`~!@#\$%\^&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]！。；、’“”]+$/;
      var val = this.pass;
      var len = val.length;
      if (re.test(val) || re1.test(val) || re2.test(val) || len > 16 || len < 6) {
        this.errorMsg = '密码需要6-16位，且必须包含两种以上字符';
        return;
      }
      if (this.pass !== this.repass) {
        this.errorMsg = '两次输入的密码不一样，请重新输入';
        return;
      }
      this.errorMsg = '';
      var url = '';
      var url2 = '';
      var tel = '';
      var eml = '';

      if (_this.telphone.indexOf('@') >= 0) {
        url = _this.baseUrl + '/find/password/validate/2';
        eml = _this.telphone;
        url2 = this.baseUrl + '/find/password/modify/2';
      } else {
        url = _this.baseUrl + '/find/password/validate/1';
        tel = _this.telphone;
        url2 = _this.baseUrl + '/find/password/modify/1';
      }
      _this.$http.post(url, { mobile: tel, email: eml, code: _this.code }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          _this.$http.post(url2, { mobile: tel, email: eml, code: _this.code, password: this.pass }, { credentials: true }).then(function (res) {
            if (res.body.type === 'success') {
              window.location = _this.ReturnURl;
            } else {
              _this.errorMsg = '修改密码失败，请检查账号是否正确';
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后再试';
          });
        } else {
          _this.errorMsg = '请输入正确的验证码';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    },
    uuid: function uuid() {
      function S4() {
        return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
      }
      return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_public_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_geetest_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__js_public_js__["a" /* default */]],
  props: {
    loginShow: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      name: '',
      pas: '',
      errorMsg: '',
      code: '',
      codeshow: false,
      id: '',
      telphone: '',
      yzm: '',
      yzmCode: '',
      page: 1,
      sendMsg: '发送短信验证码',
      wxShow: false,
      iframeSrc: '',
      ewmSrc: ''
    };
  },
  created: function created() {
    var _this = this;
    this.id = this.uuid();
    this.wxShow = this.$route.query.wx;

    this.$nextTick(function () {
      document.getElementsByTagName('title')[0].innerHTML = '登录';
      this.code = this.getUrlFn('code');
      var name = this.getUrlFn('name');
      if (this.code && name === 'qq') {
        this.loginQQ();
      } else if (this.code && name === 'wei') {
        this.loginWEI();
      } else if (this.code && name === 'bo') {
        this.loginBO();
      }
    });
  },

  methods: {
    toRegister: function toRegister() {
      this.$route.push({ name: 'register' });
    },
    getJy: function getJy() {
      if (this.$refs.jcode.innerHTML) {
        return;
      }
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
        url: _this.baseUrl + '/geetest/v3',
        type: 'POST',
        dataType: 'json',
        data: { id: _this.id },
        xhrFields: {
          withCredentials: true
        },
        success: function success(res) {
          if (res.type === 'success') {
            window.initGeetest({
              gt: res.data.gt,
              challenge: res.data.challenge,
              new_captcha: res.data.new_captcha,
              product: 'popup',
              width: '100%',
              offline: !res.data.success
            }, _this.handlerPopup);
          }
        }
      });
    },
    uuid: function uuid() {
      function S4() {
        return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
      }
      return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
    },
    changePage: function changePage(n) {
      if (this.$refs.jcode) this.$refs.jcode.innerHTML = '';
      var _this = this;
      this.codeshow = false;
      this.errorMsg = '';
      this.page = n;
      if (n === 2) {
        this.$http.post(_this.baseUrl + '/login/p/3', { redirect_uri: location.href.split('?')[0] + '?name=wei' }, { credentials: true }).then(function (res) {
          if (res.body.type === 'success') {
            _this.iframeSrc = res.body.redirectUrl;
            _this.$refs.iframe.onload = function () {
              _this.ewmSrc = document.querySelectorAll('.lightBorder')[0].src;
            };
          } else {
            _this.errorMsg = '第三方接口出现问题，请稍后再试';
          }
        }, function () {
          _this.errorMsg = '网络错误，请稍后重试';
        });
      }
    },
    sendyzm: function sendyzm() {
      var phonetest = /^1[0-9]{10}$/;
      var _this = this;
      if (this.sendMsg.length !== 7) {
        return;
      }
      if (!phonetest.test(this.telphone)) {
        this.errorMsg = '请输入正确的手机号码';
        return;
      }
      this.getJy();
      this.codeshow = true;
      this.errorMsg = '请进行图片验证';
    },
    toCode: function toCode() {
      var _this = this;
      var i = 60;
      this.sendMsg = i + '秒';
      var nu = setInterval(function () {
        i--;
        _this.sendMsg = i + '秒';
        if (i === 0) {
          clearInterval(nu);
          _this.sendMsg = '发送短信验证码';
        }
      }, 1000);
    },
    handlerPopup: function handlerPopup(captchaObj) {
      var _this = this;
      captchaObj.appendTo('.jtocode');
      captchaObj.onReady(function () {
        setTimeout(function () {
          document.getElementsByClassName('geetest_radar_btn')[0].click();
        }, 16);
      });
      captchaObj.onSuccess(function () {
        var validate = captchaObj.getValidate();
        setTimeout(function () {
          _this.codeshow = false;
        }, 1500);
        if (_this.page === 1) {
          _this.$http.post(_this.baseUrl + '/login/p/1', { geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, username: _this.name, password: _this.pas }, { credentials: true }).then(function (res) {
            if (res.body.type === 'success') {
              window.location = _this.ReturnURl;
            } else if (res.body.code === 30000020) {
              captchaObj.reset();
              _this.errorMsg = '验证不成功';
            } else {
              captchaObj.reset();
              _this.errorMsg = '用户名或者密码错误';
            }
          }, function () {
            captchaObj.reset();
            _this.errorMsg = '网络错误，请稍后重试';
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
            url: _this.baseUrl + '/login/send/5',
            type: 'POST',
            dataType: 'json',
            data: { geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, mobile: _this.telphone },
            xhrFields: {
              withCredentials: true
            },
            success: function success(data) {
              if (data.type === 'success') {
                _this.errorMsg = '';
                _this.toCode();
                captchaObj.reset();
              } else {
                _this.errorMsg = '操作频繁，请稍后再试';
                captchaObj.reset();
              }
            }
          });
        }
      });
    },
    checkMsg: function checkMsg() {
      var _this = this;

      if (this.page === 1) {
        if (this.name.trim().length < 1) {
          _this.errorMsg = '请输入用户名';
          return;
        } else if (this.pas.length < 1) {
          _this.errorMsg = '请输入密码';
          return;
        }
        _this.errorMsg = '';

        this.$http.post(_this.baseUrl + '/login/need-verify', { username: _this.name }, { credentials: true }).then(function (res) {
          if (res.body.type === 'success') {
            if (res.body.data === true) {
              _this.getJy();
              _this.codeshow = true;
            } else {
              _this.$http.post(_this.baseUrl + '/login/p/1', { username: _this.name, password: _this.pas }, { credentials: true }).then(function (res) {
                if (res.body.type === 'success') {
                  window.location = _this.ReturnURl;
                } else if (res.body.code === 11000000) {
                  _this.errorMsg = '用户名不存在，';
                } else if (res.body.code === 11000003) {
                  _this.errorMsg = '用户名或密码错误';
                }
              }, function () {
                _this.errorMsg = '网络错误，请稍后重试';
              });
            }
          } else {
            _this.errorMsg = '网络错误，请稍后重试';
          }
        }, function () {
          _this.errorMsg = '网络错误，请稍后重试';
        });
      } else if (this.page === 2) {} else if (this.page === 3) {
        var phonetest = /^1[0-9]{10}$/;
        if (!phonetest.test(this.telphone)) {
          _this.errorMsg = '请输入正确的手机号码';
        } else if (this.yzm.length < 1) {
          _this.errorMsg = '请输入验证码';
        } else {
          _this.errorMsg = '';

          _this.$http.post(_this.baseUrl + '/login/p/5', { mobile: _this.telphone, code: _this.yzm }, { credentials: true }).then(function (res) {
            if (res.body.type === 'success') {
              window.location = _this.ReturnURl;
            } else if (res.body.code === 12100001) {
              _this.errorMsg = '验证码不正确或已过期';
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后重试';
          });
        }
      }
    },
    getQQ: function getQQ() {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/p/4', { redirect_uri: location.href.split('?')[0] + '?name=qq' }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          window.location = res.body.redirectUrl;
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    },
    getWEI: function getWEI() {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/p/3', { redirect_uri: location.href.split('?')[0] + '?name=wei' }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          window.location = res.body.redirectUrl;
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    },
    getBO: function getBO() {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/p/2', { redirect_uri: location.href.split('?')[0] + '?name=bo' }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          window.location = res.body.redirectUrl;
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    },
    loginQQ: function loginQQ() {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/callback/4', { code: _this.code, redirect_uri: location.href.split('?')[0] + '?name=qq' }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          window.location = _this.ReturnURl;
        } else if (res.body.code === 11000001) {
          _this.errorMsg = '第三方登录用户属性缺失，需要注册';
          window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
        } else if (res.body.code === 11100000) {
          _this.errorMsg = '第三方登录用户需要注册';
          _this.$router.push({
            name: 'third',
            query: {
              ReturnURl: _this.ReturnURl,
              name: res.body.content,
              type: 'qq'
            }
          });
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    },
    loginWEI: function loginWEI() {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/callback/3', { code: _this.code }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          window.location = _this.ReturnURl;
        } else if (res.body.code === 11000001) {
          _this.errorMsg = '第三方登录用户属性缺失，需要注册';
          window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
        } else if (res.body.code === 11100000) {
          _this.errorMsg = '第三方登录用户需要注册';
          _this.$router.push({
            name: 'third',
            query: {
              ReturnURl: _this.ReturnURl,
              name: res.body.content,
              type: 'weixin'
            }
          });
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    },
    loginBO: function loginBO() {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/callback/2', { code: _this.code, redirect_uri: _this.ReturnURl }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          window.location = _this.ReturnURl;
        } else if (res.body.code === 11000001) {
          _this.errorMsg = '第三方登录用户属性缺失，需要注册';
          window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
        } else if (res.body.code === 11100000) {
          _this.errorMsg = '第三方登录用户需要注册';
          _this.$router.push({
            name: 'third',
            query: {
              ReturnURl: _this.ReturnURl,
              name: res.body.content,
              type: 'weibo'
            }
          });
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    },
    changeState: function changeState() {
      this.$emit('changeState');
      if (window._czc) {
        window._czc.push(['_trackEvent', '立即注册', '点击', '立即注册按钮', '1', '立即注册按钮']);
      }
    },
    forget: function forget() {
      this.$emit('forget');
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__agreement_agreement_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__agreement_agreement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__agreement_agreement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__agreement_userAgreement_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__agreement_userAgreement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__agreement_userAgreement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_geetest_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_public_js__ = __webpack_require__(10);








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__js_public_js__["a" /* default */]],
  data: function data() {
    return {
      errorMsg: '',
      email: '',
      password: '',
      telphone: '',
      code: '',
      id: '',
      codeshow: false,
      sendMsg: '发送验证码',
      onoff: false,
      alertshow: false,
      alertshow1: false,
      msg: '恭喜你，注册成功！',
      type: '',
      page: 1,
      isRead: false
    };
  },
  created: function created() {
    var _this = this;
    this.id = this.uuid();
    this.$nextTick(function () {
      document.getElementsByTagName('title')[0].innerHTML = '注册';
    });
  },

  components: {
    agreement: __WEBPACK_IMPORTED_MODULE_0__agreement_agreement_vue___default.a,
    userAgreement: __WEBPACK_IMPORTED_MODULE_1__agreement_userAgreement_vue___default.a
  },
  methods: {
    changePage: function changePage(n) {
      this.page = n;
      this.codeshow = false;
      this.errorMsg = '';
    },
    getJy: function getJy() {
      var _this = this;
      if (this.$refs.jcode.innerHTML) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.ajax({
        url: _this.baseUrl + '/geetest/v3',
        type: 'POST',
        dataType: 'json',
        data: { id: _this.id },
        xhrFields: {
          withCredentials: true
        },
        success: function success(res) {
          if (res.type === 'success') {
            window.initGeetest({
              gt: res.data.gt,
              challenge: res.data.challenge,
              new_captcha: res.data.new_captcha,
              product: 'popup',
              width: '100%',
              offline: !res.data.success
            }, _this.handlerPopup);
          }
        }
      });
    },
    agree: function agree() {
      this.onoff = true;
      this.alertshow = false;
    },
    agree1: function agree1() {
      this.onoff = true;
      this.alertshow1 = false;
    },
    unagree: function unagree() {
      this.onoff = false;
      this.alertshow = false;
    },
    unagree1: function unagree1() {
      this.onoff = false;
      this.alertshow1 = false;
    },
    close: function close() {
      this.alertshow = false;
    },
    close1: function close1() {
      this.alertshow1 = false;
    },
    alertFn: function alertFn() {
      this.alertshow = true;
      this.isRead = true;
    },
    alertFn1: function alertFn1() {
      console.log('隐私');
      this.alertshow1 = true;
      this.isRead = true;
    },
    trackAgreement: function trackAgreement() {
      if (window._czc) {
        window._czc.push(['_trackEvent', '阅读并同意', '点击', '阅读并同意', '1', '阅读并同意']);
      }
    },
    uuid: function uuid() {
      function S4() {
        return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
      }
      return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
    },
    handlerPopup: function handlerPopup(captchaObj) {
      var _this = this;
      captchaObj.appendTo('.jtocode');
      captchaObj.onReady(function () {
        setTimeout(function () {
          document.getElementsByClassName('geetest_radar_btn')[0].click();
        }, 16);
      });
      captchaObj.onSuccess(function () {
        var validate = captchaObj.getValidate();
        _this.errorMsg = '';
        setTimeout(function () {
          _this.codeshow = false;
        }, 1500);
        _this.$http.post(_this.baseUrl + '/common/exist-user', { u: _this.telphone }).then(function (res) {
          if (res.body.type === 'success') {
            if (res.body.data) {
              _this.errorMsg = '该手机号已经注册';
              captchaObj.reset();
            } else {
              __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.ajax({
                url: _this.baseUrl + '/register/semd/4',
                type: 'POST',
                dataType: 'json',
                data: { geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, mobile: _this.telphone },
                xhrFields: {
                  withCredentials: true
                },
                success: function success(data) {
                  if (data.type === 'success') {
                    _this.errorMsg = '';
                    _this.toCode();
                    captchaObj.reset();
                  } else {
                    _this.errorMsg = '操作频繁，请稍后再试';
                  }
                }
              });
            }
          }
        }, function () {
          _this.errorMsg = '网络错误，请稍后重试';
        });
      });
    },
    toCode: function toCode() {
      var _this = this;
      var i = 60;
      this.sendMsg = i + '秒';
      var nu = setInterval(function () {
        i--;
        _this.sendMsg = i + '秒';
        if (i === 0) {
          clearInterval(nu);
          _this.sendMsg = '发送验证码';
        }
      }, 1000);
    },
    sendyzm: function sendyzm() {
      if (window._czc) {
        window._czc.push(['_trackEvent', '验证码', '点击', '发送验证码按钮', '1', '发送验证码按钮']);
      }
      var phonetest = /^1[0-9]{10}$/;
      var _this = this;
      if (this.sendMsg.length !== 5) {
        return;
      }
      if (!phonetest.test(this.telphone)) {
        this.errorMsg = '请输入正确的手机号码';
        return;
      }
      this.getJy();
      this.codeshow = true;
      this.errorMsg = '请进行图片验证';
    },
    submit: function submit() {
      if (window._czc) {
        window._czc.push(['_trackEvent', '完成注册', '点击', '完成注册按钮', '1', '完成注册按钮']);
      }
      var _this = this;
      var phonetest = /^1[0-9]{10}$/;
      var emailtest = /^[A-Za-z0-9]+([-_.][A-Za-z0-9]+)*@([A-Za-z0-9]+[-.])+[A-Za-zd]{2,5}$/;
      var re = /^\d+$/;
      var re1 = /^[a-zA-Z]+$/;
      var re2 = /^[`~!@#\$%\^&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]！。；、’“”]+$/;
      var val = this.password;
      var len = val.length;
      if (!this.isRead) {
        this.errorMsg = '请点击《图灵机器人开放平台服务协议》《图灵机器人开放平台隐私权政策》进行阅读后同意';
        return;
      }
      if (!this.onoff) {
        this.errorMsg = '请阅读并同意 《图灵机器人开放平台服务协议》《图灵机器人开放平台隐私权政策》';
        return;
      }
      if (!phonetest.test(this.telphone)) {
        this.errorMsg = '请输入正确的手机号码';
        return;
      }
      if (this.email !== '' && !emailtest.test(this.email)) {
        this.errorMsg = '请输入正确邮箱格式';
        return;
      }
      if (re.test(val) || re1.test(val) || re2.test(val) || len > 16 || len < 6) {
        this.errorMsg = '密码需要6-16位，且必须包含两种以上字符';
        return;
      }
      if (!this.code) {
        this.errorMsg = '验证码不能为空';
        return;
      }
      this.errorMsg = '';

      this.$http.post(_this.baseUrl + '/common/exist-user', { u: _this.telphone }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          if (res.body.data === true) {
            _this.errorMsg = '该手机已经注册';
          } else {
            _this.$http.post(_this.baseUrl + '/common/exist-user', { u: _this.email }, { credentials: true }).then(function (res) {
              if (res.body.type === 'success') {
                if (res.body.data === true && _this.email !== '') {
                  _this.errorMsg = '该邮箱已经注册';
                } else {
                  _this.$http.post(_this.baseUrl + '/register/validate/1', { mobile: _this.telphone, code: _this.code }, { credentials: true }).then(function (res) {
                    if (res.body.type === 'success') {
                      var url = _this.baseUrl + '/register/save/4';
                      _this.$http.post(url, {
                        email: _this.email,
                        mobile: _this.telphone,
                        code: _this.code,
                        password: _this.password,
                        auto_login: true,
                        redirect_uri: '',
                        referer: _this.ReturnURl
                      }, { credentials: true }).then(function (res) {
                        if (res.body.type === 'success') {
                          window.location = _this.ReturnURl;
                        } else {
                          _this.errorMsg = '验证码错误';
                        }
                      }, function () {
                        _this.errorMsg = '网络错误，请稍后重试';
                      });
                    } else {
                      _this.errorMsg = '验证码错误';
                    }
                  }, function () {
                    _this.errorMsg = '网络错误，请稍后重试';
                  });
                }
              }
            }, function () {
              _this.errorMsg = '网络错误，请稍后重试';
            });
          }
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_geetest_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_public_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__js_public_js__["a" /* default */]],
  data: function data() {
    return {
      show: false,
      errorMsg: '该账号尚绑定手机号，快速绑定并登录',
      telphone: '',
      code: '',
      id: '',
      codeshow: false,
      sendMsg: '发送验证码',
      type: '',
      userName: ''
    };
  },
  created: function created() {
    this.id = this.uuid();
    this.type = this.$route.query.type;
    this.userName = this.$route.query.name;
    this.$nextTick(function () {
      document.getElementsByTagName('title')[0].innerHTML = '第三方登录';
    });
  },

  methods: {
    changePage: function changePage(n) {
      this.page = n;
      this.codeshow = false;
      this.errorMsg = '';
    },
    getJy: function getJy() {
      var _this = this;
      if (this.$refs.jcode.innerHTML) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
        url: _this.baseUrl + '/geetest/v3',
        type: 'POST',
        dataType: 'json',
        data: { id: _this.id },
        xhrFields: {
          withCredentials: true
        },
        success: function success(res) {
          if (res.type === 'success') {
            window.initGeetest({
              gt: res.data.gt,
              challenge: res.data.challenge,
              new_captcha: res.data.new_captcha,
              product: 'popup',
              width: '100%',
              offline: !res.data.success
            }, _this.handlerPopup);
          }
        }
      });
    },
    uuid: function uuid() {
      function S4() {
        return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
      }
      return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
    },
    handlerPopup: function handlerPopup(captchaObj) {
      var _this = this;
      captchaObj.appendTo('.jtocode');
      captchaObj.onReady(function () {
        setTimeout(function () {
          document.getElementsByClassName('geetest_radar_btn')[0].click();
        }, 16);
      });
      captchaObj.onSuccess(function () {
        var validate = captchaObj.getValidate();
        _this.errorMsg = '';
        setTimeout(function () {
          _this.codeshow = false;
        }, 1500);
        _this.$http.post(_this.baseUrl + '/common/exist-user', { u: _this.telphone }).then(function (res) {
          if (res.body.type === 'success') {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
              url: _this.baseUrl + '/register/semd/4',
              type: 'POST',
              dataType: 'json',
              data: { geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, mobile: _this.telphone },
              xhrFields: {
                withCredentials: true
              },
              success: function success(data) {
                if (data.type === 'success') {
                  _this.errorMsg = '';
                  _this.toCode();
                  captchaObj.reset();
                } else {
                  _this.errorMsg = '操作频繁，请稍后再试';
                }
              }
            });
          }
        }, function () {
          _this.errorMsg = '网络错误，请稍后重试';
        });
      });
    },
    toCode: function toCode() {
      var _this = this;
      var i = 60;
      this.sendMsg = i + '秒';
      var nu = setInterval(function () {
        i--;
        _this.sendMsg = i + '秒';
        if (i === 0) {
          clearInterval(nu);
          _this.sendMsg = '发送验证码';
        }
      }, 1000);
    },
    sendyzm: function sendyzm() {
      var phonetest = /^1[0-9]{10}$/;
      var _this = this;
      if (this.sendMsg.length !== 5) {
        return;
      }
      if (!phonetest.test(this.telphone)) {
        this.errorMsg = '请输入正确的手机号码';
        return;
      }

      this.$http.post(_this.baseUrl + '/common/need-verify', { mobile: _this.telphone }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          if (res.body.data) {
            this.getJy();
            this.codeshow = true;
            this.errorMsg = '请进行图片验证';
          } else {
            __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.ajax({
              url: _this.baseUrl + '/register/semd/3',
              type: 'POST',
              dataType: 'json',
              data: { mobile: _this.telphone },
              xhrFields: {
                withCredentials: true
              },
              success: function success(data) {
                if (data.type === 'success') {
                  _this.errorMsg = '';
                  _this.toCode();
                } else {
                  _this.errorMsg = '操作频繁，请稍后再试';
                }
              }
            });
          }
        } else {
          this.errorMsg = '网络繁忙，请稍后重试';
        }
      });
    },
    submit: function submit() {
      var _this = this;
      var phonetest = /^1[0-9]{10}$/;
      var re = /^\d+$/;
      var re1 = /^[a-zA-Z]+$/;
      var re2 = /^[`~!@#\$%\^&\*\(\)_\+<>\?:"\{\},\.\\\/;'\[\]！。；、’“”]+$/;
      if (!phonetest.test(this.telphone)) {
        this.errorMsg = '请输入正确的手机号码';
        return;
      }
      if (!this.code) {
        this.errorMsg = '验证码不能为空';
        return;
      }
      this.errorMsg = '';

      _this.$http.post(_this.baseUrl + '/register/validate/1', { mobile: _this.telphone, code: _this.code }, { credentials: true }).then(function (res) {
        if (res.body.type === 'success') {
          var url = _this.baseUrl + '/register/save/3';
          _this.$http.post(url, {
            mobile: _this.telphone,
            code: _this.code,
            auto_login: true,
            redirect_uri: '',
            register_from: { qq: 1, bo: 2, wei: 3 }[this.type],
            referer: _this.ReturnURl
          }, { credentials: true }).then(function (res) {
            if (res.body.type === 'success') {
              _this.show = true;
              window.location = _this.ReturnURl;
            } else {
              _this.errorMsg = '验证码错误';
            }
          }, function () {
            _this.errorMsg = '网络错误，请稍后重试';
          });
        } else {
          _this.errorMsg = '验证码错误';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    }
  }
});

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(94)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(106),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d4276904",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(104),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42800373",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "find-pas container",
    class: {
      height: _vm.codeshow
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "http://www.tuling123.com/"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrong",
    class: {
      active: _vm.errorMsg !== ''
    }
  }, [_vm._v(_vm._s(_vm.errorMsg) + " "), (_vm.errorMsg == '用户名不存在，') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("快速注册？")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telphone),
      expression: "telphone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号码/邮箱"
    },
    domProps: {
      "value": (_vm.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telphone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "yz"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "yz-inp",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "yz-btn",
    on: {
      "click": _vm.sendyzm
    }
  }, [_vm._v(_vm._s(_vm.sendMsg))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    attrs: {
      "type": "password",
      "placeholder": "新密码"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repass),
      expression: "repass"
    }],
    attrs: {
      "type": "password",
      "placeholder": "再次输入新密码"
    },
    domProps: {
      "value": (_vm.repass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeshow),
      expression: "codeshow"
    }],
    ref: "jcode",
    staticClass: "jtocode"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.sure
    }
  }, [_vm._v("修改并登录")]), _vm._v(" "), _c('div', {
    staticClass: "hrefs clearfix"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('span', [_vm._v("返回登录")])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tit-box"
  }, [_c('p', {
    staticClass: "tit active"
  }, [_vm._v("\n          找回密码\n        ")])])
}]}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "btm"
  }, [_vm._v("Copyright © 2025 图灵机器人 All rights Reserved ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register container",
    class: {
      height: _vm.codeshow
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "http://www.tuling123.com/"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con-wrap"
  }, [_c('div', {
    staticClass: "tit-box"
  }, [_c('p', {
    staticClass: "tit active",
    on: {
      "click": function($event) {
        return _vm.changePage(1)
      }
    }
  }, [_vm._v("账号注册")])]), _vm._v(" "), _c('div', {
    staticClass: "wrong",
    class: {
      active: _vm.errorMsg !== ''
    }
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "necessary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telphone),
      expression: "telphone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telphone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "necessary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "necessary"
  }, [_c('div', {
    staticClass: "yz"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "yz-inp",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "yz-btn",
    on: {
      "click": _vm.sendyzm
    }
  }, [_vm._v(_vm._s(_vm.sendMsg))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeshow),
      expression: "codeshow"
    }],
    ref: "jcode",
    staticClass: "jtocode"
  })]), _vm._v(" "), _c('div', {
    staticClass: "read"
  }, [_c('span', [_c('label', {
    attrs: {
      "for": "sel"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onoff),
      expression: "onoff"
    }],
    attrs: {
      "type": "checkbox",
      "name": "",
      "id": "sel"
    },
    domProps: {
      "checked": Array.isArray(_vm.onoff) ? _vm._i(_vm.onoff, null) > -1 : (_vm.onoff)
    },
    on: {
      "click": _vm.trackAgreement,
      "change": function($event) {
        var $$a = _vm.onoff,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.onoff = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.onoff = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onoff = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "selbox",
    class: _vm.onoff ? 'active' : ''
  }), _vm._v("阅读并同意\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "col",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.alertFn.apply(null, arguments)
      }
    }
  }, [_vm._v("《图灵机器人开放平台服务协议》")]), _vm._v(" "), _c('span', {
    staticClass: "col",
    staticStyle: {
      "display": "block",
      "padding-left": "85px",
      "padding-top": "8px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.alertFn1.apply(null, arguments)
      }
    }
  }, [_vm._v("《图灵机器人开放平台隐私权政策》")])])]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("注册")]), _vm._v(" "), _c('div', {
    staticClass: "hrefs clearfix"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('span', [_vm._v("已有账号？")]), _vm._v("登录")])], 1)])]), _vm._v(" "), _c('agreement', {
    attrs: {
      "alertshow": _vm.alertshow
    },
    on: {
      "close": _vm.close,
      "agree": _vm.agree,
      "unagree": _vm.unagree
    }
  }), _vm._v(" "), _c('user-agreement', {
    attrs: {
      "alertshow1": _vm.alertshow1
    },
    on: {
      "close1": _vm.close1,
      "agree1": _vm.agree1,
      "unagree1": _vm.unagree1
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.alertshow1) ? _c('div', {
    staticClass: "alert"
  }, [_c('div', {
    staticClass: "con"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btm"
  }, [_c('div', {
    staticClass: "fal",
    on: {
      "click": _vm.unagree
    }
  }, [_vm._v("拒绝")]), _vm._v(" "), _c('div', {
    staticClass: "tru",
    class: {
      active: _vm.isRead
    },
    on: {
      "click": _vm.agree
    }
  }, [_vm._v("同意"), (!_vm.isRead) ? _c('i', [_vm._v("(" + _vm._s(_vm.num) + "s)")]) : _vm._e()])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tit"
  }, [_c('strong', [_vm._v("图灵机器人开放平台隐私权政策")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("版本更新日期：2022年9月29日")]), _vm._v(" "), _c('h3', [_vm._v("版本发布日期：2022年9月29日")]), _vm._v(" "), _c('p', [_vm._v("欢迎您使用图灵机器人开发平台（以下简称“图灵机器人平台”）产品与/或服务，北京光年无限科技有限公司是（注册地址："), _c('strong', [_vm._v("北京市石景山区石景山路3号玉泉大厦四层常青藤青年创业工作室193号")]), _vm._v("，以下简称“"), _c('strong', [_vm._v("我们")]), _vm._v("”）系图灵机器人开放平台的运营者。我们一向尊重并会严格保护用户在使用本产品时的合法权益（包括用户信息、隐私信息等）。鉴于此，我们制定本《隐私政策》（以下称为“本政策”），与"), _c('strong', [_vm._v("您确认关于您在使用平台产品与/或服务期间，我们收集、存储、使用、披露和保护您的个人信息的相关事宜，请您在开始使用我们平台服务之前请务必仔细阅读并理解")]), _vm._v("。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("如您是未成年人，请在您的父母或其他监护人陪同下仔细阅读并充分理解本政策，并征得您的父母或其他监护人的同意后使用图灵机器人平台产品与/或服务。")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("因为只要您使用我们的服务，就表示您同意隐私政策及补充条文中所描述的做法，如果您不同意隐私政策中所描述的做法，您可以选择不使用我们的服务。")])]), _vm._v(" "), _c('h3', [_vm._v("本政策将帮助您了解以下内容：")]), _vm._v(" "), _c('p', [_vm._v("一、定义与解释")]), _vm._v(" "), _c('p', [_vm._v("二、我们如何收集和使用您的个人信息")]), _vm._v(" "), _c('p', [_vm._v("三、我们如何使用 Cookie 和同类技术")]), _vm._v(" "), _c('p', [_vm._v("四、我们如何委托处理、共享、转让、公开披露您的个人信息")]), _vm._v(" "), _c('p', [_vm._v("五、我们如何保护您的个人信息")]), _vm._v(" "), _c('p', [_vm._v("六、我们如何存储您的个人信息")]), _vm._v(" "), _c('p', [_vm._v("七、我们如何保护未成年人的个人信息")]), _vm._v(" "), _c('p', [_vm._v("八、您如何行使管理您个人信息的权利")]), _vm._v(" "), _c('p', [_vm._v("九、我们如何更新本政策")]), _vm._v(" "), _c('p', [_vm._v("十、如何联系我们")]), _vm._v(" "), _c('p', [_vm._v("十一、其他")]), _vm._v(" "), _c('h3', [_vm._v("一、定义与解释")]), _vm._v(" "), _c('p', [_vm._v("1、"), _c('strong', [_vm._v("个人信息")]), _vm._v("：是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。为免疑义，个人信息包括但不限于敏感个人信息。")]), _vm._v(" "), _c('p', [_vm._v("2、"), _c('strong', [_vm._v("敏感个人信息")]), _vm._v("：是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，"), _c('strong', [_vm._v("包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("3、"), _c('strong', [_vm._v("个人信息的处理")]), _vm._v("：包括个人信息的收集、存储、使用、加工、传输、提供、公开、删除等。")]), _vm._v(" "), _c('p', [_vm._v("4、"), _c('strong', [_vm._v("用户")]), _vm._v("：是指"), _c('strong', [_vm._v("1）访问图灵机器人网站；2）注册、登录以及使用图灵机器人产品与/或服务的用户；3）通过启用、浏览或上传数据至图灵机器人平台的访问者和开发者；4）使用调用了图灵机器人平台人工智能API/SDK产品与/或服务的最终用户。")]), _vm._v("在本政策中更多地称为“您”。")]), _vm._v(" "), _c('p', [_vm._v("5、"), _c('strong', [_vm._v("账号")]), _vm._v("：是指您在图灵机器人平台完成注册用户账号，账号由您自行保管且承担使用账号的相关法律责任。")]), _vm._v(" "), _c('p', [_vm._v("6、"), _c('strong', [_vm._v("匿名化")]), _vm._v("：是指个人信息经过处理无法识别特定自然人且不能复原的过程。")]), _vm._v(" "), _c('p', [_vm._v("7、"), _c('strong', [_vm._v("去标识化")]), _vm._v("：是指个人信息经过处理，使其在不借助额外信息的情况下，无法识别特定自然人的过程。")]), _vm._v(" "), _c('p', [_vm._v("8、"), _c('strong', [_vm._v("IP地址")]), _vm._v("：每台上网的设备都会指定一个编号，称为互联网协议 (IP) 地址。这些编号通常都是根据地理区域指定的。IP 地址通常可用于识别设备连接至互联网时所在的位置。")]), _vm._v(" "), _c('h3', [_vm._v("二、我们如何收集和使用您的个人信息")]), _vm._v(" "), _c('p', [_vm._v("1、我们作为您访问、注册或使用图灵机器人平台产品与/或服务时，有关您个人信息的处理者，会遵循合法、正当、必要、诚信的原则，仅将我们主动收集的个人信息和您主动提供的个人信息用于本政策所限定的用途并为您提供个性化服务，以及用于身份验证、安全防范、反诈骗监测以提高产品与/或服务的安全性。为此，我们可能会在您注册、登录、实名认证、使用我们平台产品与/或服务时收集和使用您的个人信息（该类信息包括您的姓名/名称、身份证号码、手机号码、电子邮箱账号等）。")]), _vm._v(" "), _c('p', [_vm._v("2、我们可能会对我们提供的服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以用于产品开发、服务优化、安全保障的目的。但这些统计信息不包含您的任何身份识别信息。")]), _vm._v(" "), _c('p', [_vm._v("3、根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息而无需征求您的授权同意：")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(1)与我们履行法律法规规定的义务相关的；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(2)与国家安全、国防安全直接相关的；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(3)与公共安全、公共卫生、重大公共利益直接相关的；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(4)与刑事侦查、起诉、审批和判决执行等直接相关的；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(5)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(6)所涉及的个人信息是个人信息主体或监护人自行向社会公众公开的；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(7)根据个人信息主体要求签订和履行合同所必需的；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(8)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(9)维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障。")])]), _vm._v(" "), _c('h3', [_vm._v("三、我们如何使用 Cookies 和同类技术")]), _vm._v(" "), _c('h4', [_c('strong', [_vm._v("1.我们如何使用Cookies")])]), _vm._v(" "), _c('p', [_vm._v("(1)通过使用Cookies，我们向用户提供安全且具个性化的服务体验。我们和第三方合作伙伴会在您的终端设备上存储Cookies、Flash Cookies，或浏览器（或关联应用程序）提供的其他通常包含标识符、站点名称以及一些号码和字符的本地存储（以上合称“Cookies”）。我们和我们的第三方合作伙伴可能通过Cookies收集您的信息，并将信息用于以下用途：安全类Cookies：Cookies可帮助我们保障产品和服务的安全和高效运转。")]), _vm._v(" "), _c('p', [_vm._v("(2)"), _c('strong', [_vm._v("通过平台跳转到第三方平台时或您通过第三方渠道获取我方服务时，该渠道通过Cookies收集和使用您的信息不受本政策约束，而是受到其自身的信息保护声明约束，我们不对第三方的Cookies或同类技术承担责任。")])]), _vm._v(" "), _c('h3', [_vm._v("四、我们如何委托处理、共享、转让、公开披露您的个人信息")]), _vm._v(" "), _c('p', [_vm._v("1、"), _c('strong', [_vm._v("委托处理")]), _vm._v("：我们会委托第三方服务提供商处理我们所收集的您的个人信息，以便其为我们提供基础设施技术、数据分析等产品或技术支持。上述委托处理行为受本政策中所声明目的约束，并且我们会以合同的方式对上述受托的第三方服务提供商进行监督。")]), _vm._v(" "), _c('p', [_vm._v("2、"), _c('strong', [_vm._v("共享")]), _vm._v("：")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("（1）我们可能会与我们的关联公司或合作伙伴共享您的个人信息、用户日志等数据；但是我们只会共享必要的个人信息及日志数据，且受本政策中所声明目的的约束；关联公司也将依据本政策采取同等的安全保障措施来保障您的个人信息安全。")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("（2）根据适用的法律法规规定，或按照政府主管部门的强制性要求进行提供。")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("3、转让")])]), _vm._v(" "), _c('p', [_vm._v("我们不会将您的个人信息转让给任何公司、组织和个人，"), _c('strong', [_vm._v("但在涉及合并、收购、资产转让或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新取得您的授权同意。")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4、公开披露")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("除")]), _vm._v("根据相关法律及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得您的授权同意"), _c('strong', [_vm._v("的例外情况外，本政策另有约定或法律明确规定，我们不会公开披露您的个人信息。例外情况如下：")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(1)与我们履行法律法规规定的义务相关的；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(2)与国家安全、国防安全直接相关的；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(3)与公共安全、公共卫生、重大公共利益直接相关的；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(4)与刑事侦查、起诉、审判和判决执行等直接相关的；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(5)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(6)个人信息主体或监护人自行向社会公众公开的个人信息；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(7)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。")])]), _vm._v(" "), _c('p', [_vm._v("2."), _c('strong', [_vm._v("请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您谨慎共享或公开，如所涉信息包含他人个人信息，请您在共享或公开前取得他人同意。")])]), _vm._v(" "), _c('p', [_vm._v("3."), _c('strong', [_vm._v("请知悉，根据法律规定，若我们采取技术措施和其他必要措施处理个人信息，使得数据接收方无法重新识别特定个人且不能复原，经上述处理后的数据的共享、转让、公开披露无需另行向您通知并征得您的同意。")])]), _vm._v(" "), _c('h3', [_vm._v("五、我们如何保护您的个人信息")]), _vm._v(" "), _c('p', [_vm._v("1、我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。")]), _vm._v(" "), _c('p', [_vm._v("2、"), _c('strong', [_vm._v("请您知悉，虽然我们将尽力确保或担保您发送给我们的任何信息的安全性，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网环境并非百分之百安全，您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题，我们亦不对由此产生或与之相关的任何风险、损失承担责任。")])]), _vm._v(" "), _c('h3', [_vm._v("六、我们如何存储您的个人信息")]), _vm._v(" "), _c('p', [_vm._v("1、我们将在本政策载明的目的所需及法律法规要求的最短保存期限之内，保存您的个人信息、用户日志等信息。前述期限届满后，我们将对您的个人信息做删除或匿名化处理。")]), _vm._v(" "), _c('p', [_vm._v("2、我们在中国境内运营过程中收集和产生的个人信息将保存在中国境内（为本隐私政策之目的，“中国境内”不含中国港澳台地区），以下情形除外：")]), _vm._v(" "), _c('p', [_vm._v("(1)"), _c('strong', [_vm._v("法律有明确规定；")])]), _vm._v(" "), _c('p', [_vm._v("(2)"), _c('strong', [_vm._v("获得您的明确授权；")])]), _vm._v(" "), _c('p', [_vm._v("(3)"), _c('strong', [_vm._v("您要求获取境外服务等个人主动行为。")])]), _vm._v(" "), _c('h3', [_vm._v("七、我们如何保护未成年人的个人信息")]), _vm._v(" "), _c('p', [_vm._v("1、我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，收集、使用未满14周岁的未成年人的个人信息，需由监护人授权同意；收集、使用已满14周岁未满18周岁的未成年人个人信息，可由监护人授权同意或自行授权同意。")]), _vm._v(" "), _c('p', [_vm._v("2、"), _c('strong', [_vm._v("如您为未成年人（尤其是不满14周岁的未成年人），我们要求您请您的父母或其他监护人仔细阅读本隐私政策，并在征得您的监护人授权同意的前提下使用我们的服务或向我们提供信息。")])]), _vm._v(" "), _c('p', [_vm._v("3、"), _c('strong', [_vm._v("如您是未成年人的监护人，请您关注您所监护的未成年人是否是在您授权同意之后使用我们的产品或服务。如果您对您所监护的未成年人的个人信息有疑问，请通过本隐私政策载明的方式与我们联系。")])]), _vm._v(" "), _c('h3', [_vm._v("八、您如何行使管理您个人信息的权利")]), _vm._v(" "), _c('p', [_vm._v("1、在您使用图灵机器人平台产品与/或服务期间，"), _c('strong', [_vm._v("您可以通过相应页面提示对您的信息进行变更、删除等操作")]), _vm._v("或本隐私政策载明的方式联系我们，以访问、更正、删除您的个人信息，以及行使注销账号的权利，您的意见会及时得到处理。")]), _vm._v(" "), _c('p', [_vm._v("2、"), _c('strong', [_vm._v("删除您的个人信息")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("在以下情形中，您可以通过本隐私政策载明的方式向我们提出删除个人信息的请求：")])]), _vm._v(" "), _c('p', [_vm._v("(1)"), _c('strong', [_vm._v("我们违反法律、行政法规或与您的约定收集、使用个人信息；")])]), _vm._v(" "), _c('p', [_vm._v("(2)"), _c('strong', [_vm._v("我们违反法律、行政法规或与您的约定与第三方共享或转让您的个人信息，我们将立即停止共享、转让行为，并通知第三方及时删除；")])]), _vm._v(" "), _c('p', [_vm._v("(3)"), _c('strong', [_vm._v("我们违反法律、行政法规规定或与您的约定，公开披露您的个人信息，我们将立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("您不再使用我们的产品或服务，或我们终止服务及运营。")])]), _vm._v(" "), _c('h3', [_vm._v("九、我们如何更新本政策")]), _vm._v(" "), _c('p', [_vm._v("1、我们的隐私政策可能会适时发生变更。我们会在本页面上发布对本隐私政策所做的任何变更。对于重大变更，我们还会提供更为显著的通知（我们可能会通过在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。"), _c('strong', [_vm._v("未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。")])]), _vm._v(" "), _c('p', [_vm._v("2、本隐私政策所指的重大变更包括但不限于：")]), _vm._v(" "), _c('p', [_vm._v("（1）我们的服务模式发生重大变化；")]), _vm._v(" "), _c('p', [_vm._v("（2）个人信息共享、转让或公开披露的主要对象发生变化；")]), _vm._v(" "), _c('p', [_vm._v("（3）您参与个人信息处理方面的权利及其行使方式发生重大变化；")]), _vm._v(" "), _c('p', [_vm._v("（4）我们的联系方式及投诉渠道发生变化；")]), _vm._v(" "), _c('p', [_vm._v("（5）个人信息安全影响评估报告表明存在高风险时。")]), _vm._v(" "), _c('p', [_vm._v("3、我们还会将本隐私政策的旧版本存档，供您查阅。")]), _vm._v(" "), _c('h3', [_vm._v("十、如何联系我们")]), _vm._v(" "), _c('p', [_vm._v("如果您对本政策或个人信息保护有任何问题，您可以将您的书面疑问、意见或建议通过以下地址寄至客服部门：")]), _vm._v(" "), _c('p', [_vm._v("名称："), _c('strong', [_vm._v("【图灵机器人】")])]), _vm._v(" "), _c('p', [_vm._v("地址："), _c('strong', [_vm._v("【北京市海淀区农大南路硅谷亮城5号楼6层】")])]), _vm._v(" "), _c('p', [_vm._v("或您也可以通过以下电子邮箱进行联系：")]), _vm._v(" "), _c('p', [_vm._v("联系邮箱："), _c('strong', [_vm._v("【turing@uzoo.cn】")])]), _vm._v(" "), _c('p', [_vm._v("一般情况下，我们将在十五个工作日内回复。"), _c('strong', [_vm._v("如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向有关监管部门进行投诉或举报，或通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。")])]), _vm._v(" "), _c('h3', [_vm._v("十一、其他")]), _vm._v(" "), _c('p', [_vm._v("1、与本政策相关的任何纠纷，双方应经友好协商解决；若不能协商解决，您在此同意向北京市石景山区人民法院提起诉讼。")]), _vm._v(" "), _c('p', [_vm._v("2、如果有管辖权的任何法院裁定或判决本政策的任何条款无效，则该条款将从本政策中移除，但该条款的无效不影响本政策其余条款的效力。本政策的其余条款将继续执行。")])])])
}]}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login container",
    class: {
      height: _vm.codeshow
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "http://www.tuling123.com/"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con-wrap"
  }, [_c('div', {
    staticClass: "tit-box"
  }, [_c('p', {
    staticClass: "tit",
    class: {
      active: _vm.page == 1
    },
    on: {
      "click": function($event) {
        return _vm.changePage(1)
      }
    }
  }, [_vm._v("账号登录")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wxShow == 1),
      expression: "wxShow==1"
    }],
    staticClass: "tit",
    class: {
      active: _vm.page == 2
    },
    on: {
      "click": function($event) {
        return _vm.changePage(2)
      }
    }
  }, [_vm._v("微信登录")]), _vm._v(" "), _c('p', {
    staticClass: "tit",
    class: {
      active: _vm.page == 3
    },
    on: {
      "click": function($event) {
        return _vm.changePage(3)
      }
    }
  }, [_vm._v("短信登录")])]), _vm._v(" "), _c('div', {
    staticClass: "wrong",
    class: {
      active: _vm.errorMsg !== ''
    }
  }, [_vm._v(_vm._s(_vm.errorMsg) + " "), (_vm.errorMsg == '用户名不存在，') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("快速注册？")]) : _vm._e()], 1), _vm._v(" "), (_vm.page == 1) ? _c('div', {
    staticClass: "con-page"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "name",
    attrs: {
      "type": "text",
      "placeholder": "用户名/手机号/注册邮箱",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pas),
      expression: "pas"
    }],
    staticClass: "pas",
    attrs: {
      "type": "password",
      "placeholder": "密码",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.pas)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkMsg.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pas = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeshow),
      expression: "codeshow"
    }],
    ref: "jcode",
    staticClass: "jtocode"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.checkMsg
    }
  }, [_vm._v("登录")])]) : _vm._e(), _vm._v(" "), (_vm.page == 2) ? _c('div', {
    staticClass: "con-page"
  }, [_c('div', {
    staticClass: "ewm"
  }, [(_vm.ewmSrc !== '') ? _c('img', {
    attrs: {
      "src": _vm.ewmSrc,
      "alt": "二维码"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.page == 3) ? _c('div', {
    staticClass: "con-page"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telphone),
      expression: "telphone"
    }],
    staticClass: "cal",
    attrs: {
      "type": "text",
      "placeholder": "手机号码",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telphone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "yz"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yzm),
      expression: "yzm"
    }],
    staticClass: "yz-inp",
    attrs: {
      "type": "text",
      "placeholder": "短信验证码",
      "maxlength": "8"
    },
    domProps: {
      "value": (_vm.yzm)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkMsg.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yzm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "yz-btn",
    on: {
      "click": _vm.sendyzm
    }
  }, [_vm._v(_vm._s(_vm.sendMsg))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeshow),
      expression: "codeshow"
    }],
    ref: "jcode",
    staticClass: "jtocode"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.checkMsg
    }
  }, [_vm._v("登录")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hrefs clearfix"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.changeState
    }
  }, [_vm._v("立即注册")])]), _vm._v(" "), (_vm.page == 1) ? _c('router-link', {
    staticClass: "res",
    attrs: {
      "to": {
        name: 'findPas'
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.forget
    }
  }, [_vm._v("忘记密码")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "login-way"
  }, [_vm._v("使用第三方账号登录")]), _vm._v(" "), _c('div', {
    staticClass: "elLogin"
  }, [_c('a', {
    staticClass: "el1",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.getQQ
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "el2",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.getWEI
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "el3",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.getBO
    }
  })])])]), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "iframe",
    attrs: {
      "src": _vm.iframeSrc,
      "frameborder": "0"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.alertshow) ? _c('div', {
    staticClass: "alert"
  }, [_c('div', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("图灵机器人开放平台服务协议")]), _vm._v(" "), _c('div', {
    staticClass: "btm"
  }, [_c('div', {
    staticClass: "fal",
    on: {
      "click": _vm.unagree
    }
  }, [_vm._v("拒绝")]), _vm._v(" "), _c('div', {
    staticClass: "tru",
    class: {
      active: _vm.isRead
    },
    on: {
      "click": _vm.agree
    }
  }, [_vm._v("同意"), (!_vm.isRead) ? _c('i', [_vm._v("(" + _vm._s(_vm.num) + "s)")]) : _vm._e()])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "p2"
  }, [_vm._v("一、授权内容")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v(" 本协议的授权产品是北京光年无限科技有限公司（以下简称“本公司”）开发的图灵机器人开放平台（以下简称“图灵开放平台”），是采用了本公司拥有自主知识产权的聊天机器人相关服务平台。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('i', {
    staticClass: "fb"
  }, [_vm._v("【审慎阅读】您在申请注册流程中点击同意本协议之前，请认真阅读本协议。")]), _vm._v("本协议在用户和本公司间具有合同上的法律效力。本协议可由本公司随时更新，用户可在图灵开放平台网站查阅最新版协议内容。如在本公司修改协议后，用户不接受修改后的协议，请立即停止使用聊天机器人相关服务，如用户选择继续使用，将视为已接受修改后的协议。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("【签约动作】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与本公司达成一致，成为图灵开放平台的“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。一经注册或使用本协议下任何服务即视为对本协议条款的理解和接受，用户违反本协议时本公司有权按其违反情况限制或停止向用户提供，并有权追究用户的相关责任。")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("二、服务使用")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("1.在您开始注册程序使用图灵开放平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。"), _c('i', {
    staticClass: "fb"
  }, [_vm._v("若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("2.在使用图灵开放平台服务时，您应当按图灵开放平台页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话等），以便图灵开放平台与您联系、确认。"), _c('i', {
    staticClass: "fb"
  }, [_vm._v("您了解并同意，您有义务保持您提供信息的真实性及有效性。")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("3.凡本网站的内容，包括但不限于Logo、文字、图片、动图，版权均属本公司所有，任何媒体、网站或其他任何形式的法律实体和个人均不得转载、链接或以其他方式复制传播。与本公司签订相关协议或已经获得本公司书面授权许可的媒体、网站或其他任何形式的法律实体和个人，应在授权范围内使用，并注明来源“图灵机器人官网” 或来源“图灵机器人开放平台”。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("4.除非本公司另行声明外，由本公司运营的网站及客户端内所有产品、技术、软件、程序、数据及其他信息（包括文字、图标、图片、照片、音频、视频、图表、色彩组合、版面设计、商标、商号、域名等）的所有权利（包括但不限于著作权、商标权、专利权、商业秘密等相关权利）均属本公司所有。任何媒体、网站或其他任何形式的法律实体和个人未经本公司书面授权，不得复制、转载、摘编、修改、链接、镜像或以其他方式展示、传播上述内容。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("5.本公司对“图灵机器人、TURING ROBOT、图宝”文字和/或LOGO均进行了商标注册保护，图灵机器人的注册商标信息，可见诸于我国公开的商标注册信息中。任何媒体、网站或其他任何形式的法律实体和个人未经本公司的书面许可不得使用上述商标。")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("三、知识产权")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("1.本公司保证，图灵开放平台所涉及的知识产权全部归本公司所有，为本公司开发、设计，并无抄袭、仿冒、节录或改编他人相同或相似功能软件或侵害他人知识产权。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("2.本公司保证任何第三方都不能因用户按本协议约定方式使用本平台服务而向用户索取任何权利或要求。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("3.平台涉及一方专有的和非公开的知识、方法以及其它信息，在开发过程中虽为另一方获知或者使用，知识产权仍归原有一方所有。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("4.本公司保证，本协议中所涉及的合作标的的知识产权不存在任何瑕疵，不会侵犯任何第三方的合法权益。")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("四、保密条款")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("1.本公司尊重并保护所有使用图灵开放平台用户的个人隐私，您注册时所授权使用或填写的个人资料，非经您亲自许可或根据相关法律、法规的强制性规定，图灵开放平台不会主动向第三方披露。资料应包括但不限于双方提供的一切设计开发有关的信息、结果，以及协议联系期间双方或双方代表与对方交流的对方以前未知的信息。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("2.本公司不允许任何人在未经用户同意的情况利用本公司提供的服务以任何手段编辑、出售、传播用户的资料。一经发现用户实施上述行为，本公司有权立即终止与该用户的服务协议，终止为其提供任何聊天机器人服务，并有权追究其法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "p2 fb"
  }, [_vm._v("五、免责声明")]), _vm._v(" "), _c('p', {
    staticClass: "p1 fb"
  }, [_vm._v("1.图灵开放平台是一个向开发者提供聊天对话技术服务的开放平台，如任何单位或个人开发者基于图灵开放平台提供的聊天对话技术进行开发、发布、传送、传播、储存违反国家法律法规禁止的内容，或利用机器人在虚拟软件模拟真人进行诈骗、诱骗等违法行为导致他人的经济利益受到损失，由此所产生的一切法律责任均与本公司无关。")]), _vm._v(" "), _c('p', {
    staticClass: "p1 fb"
  }, [_vm._v("2.如发现用户违反授权协议条约的行为，本公司有权进行独立判断并随时限制、冻结或终止该账号的使用。由此给违规者带来的数据、经济或其他损失，由违规者自行承担。")]), _vm._v(" "), _c('p', {
    staticClass: "p1 fb"
  }, [_vm._v("3.鉴于聊天机器人关联服务需要网络支撑，本公司有权对提供网路服务的平台或相关设备进行部分或全部的维护、切换，如因此类情况造成的网络服务在一定时间内出现中断，本公司无需通知用户，也无需承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "p1 fb"
  }, [_vm._v("4.如图灵开放平台的系统发生故障影响到所提供服务的正常运行，图灵开放平台承诺在第一时间内与相关单位配合，及时处理进行修复。但用户因此而产生的经济损失，本公司不承担责任。此外，图灵开放平台保留不经事先通知进行维修保养、升级或其他目的暂停本服务任何部分的权利。对此，请用户知悉并及时保存资料，否则，因此导致用户资料丢失，图灵开放平台不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("六、协议终止")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("1.如遇下列情况之一，经一方发出书面通知后即可提前终止协议：")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("）任何一方严重违反本协议的实质性义务，经守约方书面通知（书面形式包括通知函、传真、以及邮件等方式）后，在规定期限内未能采取有效的补救措施以纠正违约行为的；")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("2）除适用破产法所禁止的情形外，如果任何一方出于债权人的利益，已被指定接收人或资产受让人、或破产或无力偿付到期债务或因其他事由丧失履约能力；本协议无论因何种原因终止后，本协议保密、知识产权、抗辩、违约责任及其他依其性质应继续有效的条款应继续有效，并不损害受损方寻求其它救济的权利。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("2.用户应按照本公司的标准规定使用本平台，如用户出现违反授权协议条约的行为，则本公司有权未经通知用户即停止向用户提供聊天机器人服务，终止协议。")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("七、其它条款")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("1. 本公司对本协议条款拥有最终解释权。")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("2. 执行本协议所发生的以及与本协议有关的一切争议，双方友好协商解决，若协商不成，双方同意提交本公司所在地人民法院诉讼解决。")])])])
}]}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "find-pas container",
    class: {
      height: _vm.codeshow
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "http://www.tuling123.com/"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrong",
    class: {
      active: _vm.errorMsg !== ''
    }
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "wx-name"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telphone),
      expression: "telphone"
    }],
    staticClass: "cal",
    attrs: {
      "type": "text",
      "placeholder": "手机号码",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telphone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "yz"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "yz-inp",
    attrs: {
      "type": "text",
      "placeholder": "短信验证码",
      "maxlength": "8"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendyzm.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sent yz-btn",
    on: {
      "click": _vm.sendyzm
    }
  }, [_vm._v(_vm._s(_vm.sendMsg))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeshow),
      expression: "codeshow"
    }],
    ref: "jcode",
    staticClass: "jtocode"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("绑定并登录")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tit-box"
  }, [_c('p', {
    staticClass: "tit active"
  }, [_vm._v("\n          第三方登录\n        ")])])
}]}

/***/ }),
/* 108 */,
/* 109 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[51]);


// WEBPACK FOOTER //
// static/js/app.c8fef160b8cd1682ef16.js